import {
    GET_CALENDAR_PLAYERS_SUCCESS,
    DELETE_USER_PLAYER_SECCESS,
    PSEUDONONYMIZE_USER_PLAYER_SECCESS,
    DOWNLOAD_EXPORT_FILE_SUCCESS,
    DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS
} from './constants';
import { SET_CALENDAR_FILTER_PLAYER_SUCCESS } from '../../../data/calendar/players/constants';

const initialPlayersState = [];
/**
 *
 * @param state
 * @param action
 * @returns {*|Array|playersReducer}
 */
const calendarPlayersReducer = ( state = initialPlayersState, action ) => {
    switch ( action.type ) {
        case SET_CALENDAR_FILTER_PLAYER_SUCCESS: {
            return { ...action.players };
        }
        case GET_CALENDAR_PLAYERS_SUCCESS:
            return { ...action.players };

        case DELETE_USER_PLAYER_SECCESS:
            return action.players;
        case PSEUDONONYMIZE_USER_PLAYER_SECCESS:
            return action.players;
        case DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS:
            return action.players.current_data;
        default:
            return state;
    }
};

const initailFileState = {
    url: null
};
/**
 *
 * @param state
 * @param action
 * @returns {{url: null}|{url: *}}
 */
const excelFileReducer = ( state = initailFileState, action ) => {
    switch ( action.type ) {
        case DOWNLOAD_EXPORT_FILE_SUCCESS: {
            return { ...state, url: action.file.url };
        }
        default:
            return state;
    }
};


export { calendarPlayersReducer as calendarPlayers, excelFileReducer as excelFile };